export default __webpack_public_path__ + "daaac8a644ebb19628f58ac25ad05385.png";